import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { ProductType, client } from '@chegg/pricing-sdk';
import { BASE_EXPERIMENT, DEFAULT_PRICING_TIMEOUT, US_COUNTRY_CODE, getDataRequested } from '../hooks/usePricingAsync';
import { Severity, captureError } from '@chegg/observability';
import { CW_TEAM_NAME } from '../constants/Strings';
import { PRODUCT_TYPE_TO_OFFER_ID } from '../common/interfaces';
export var COMMERCE_UTILS_GET_PRICING_ERROR = 'commerce-utils-fetch-pricing-error';
export var fetchPricing = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var dataRequested, _ref$productCode, productCode, _ref$countryCode, countryCode, _ref$openToUpgrade, openToUpgrade, pricePlanInput, _yield$client$pricing, data, errors, success;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          dataRequested = _ref.dataRequested, _ref$productCode = _ref.productCode, productCode = _ref$productCode === void 0 ? ProductType.CHEGG_STUDY : _ref$productCode, _ref$countryCode = _ref.countryCode, countryCode = _ref$countryCode === void 0 ? US_COUNTRY_CODE : _ref$countryCode, _ref$openToUpgrade = _ref.openToUpgrade, openToUpgrade = _ref$openToUpgrade === void 0 ? false : _ref$openToUpgrade, pricePlanInput = _ref.pricePlanInput;
          _context.prev = 1;
          _context.next = 4;
          return client.pricingApi.getPricingV2({
            countryCode: countryCode,
            dataRequested: dataRequested !== null && dataRequested !== void 0 ? dataRequested : getDataRequested(countryCode),
            experiment: BASE_EXPERIMENT,
            // @ts-ignore
            offerId: PRODUCT_TYPE_TO_OFFER_ID[productCode],
            productCode: productCode,
            openToUpgrade: openToUpgrade,
            pricePlanInput: pricePlanInput
          }, {
            timeout: DEFAULT_PRICING_TIMEOUT
          });
        case 4:
          _yield$client$pricing = _context.sent;
          data = _yield$client$pricing.data;
          errors = _yield$client$pricing.errors;
          success = _yield$client$pricing.success;
          return _context.abrupt("return", {
            data: data,
            errors: errors,
            success: success
          });
        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](1);
          /** Using CaptureError here instead of Commerce New Relic Error because
           * that is the current pattern.  We may prefer to use Capture Commerce
           * New Relic Error
           */
          captureError({
            error: _context.t0,
            location: COMMERCE_UTILS_GET_PRICING_ERROR,
            severity: Severity.ERROR
          }, {
            teamName: CW_TEAM_NAME
          });
          return _context.abrupt("return", {
            errors: [_context.t0],
            success: false
          });
        case 15:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 11]]);
  }));
  return function fetchPricing(_x) {
    return _ref2.apply(this, arguments);
  };
}();
export default fetchPricing;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/fetchPricing.js
// module id = 4133
// module chunks = 11